/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={
                  "https://thumbs.dreamstime.com/b/el-pu%C3%B1o-apretado-llev%C3%B3-cabo-alto-30744569.jpg"
                }
                icon="touch_app"
                title={
                  <>
                    Unite a
                    <br />
                    la Lucha
                  </>
                }
                description="Somos mas de 500 Panaderos y Panaderas en toda la provincia luchando por mejores condiciones de trabajo dia a dia"
              />
              <RotatingCardBack
                image={
                  "https://st.depositphotos.com/1002111/4693/i/450/depositphotos_46932261-stock-photo-family-play-over-sunrise.jpg"
                }
                title="Y disfruta de ser parte"
                description="Todos nuestros afiliados cuentan con beneficios exclusivos que mejorarán no solo tu calidad de trabajo, sino tu calidad de vida."
                action={{
                  type: "internal",
                  route: "/afiliate",
                  label: "Afiliate",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="content_copy"
                  title="Asesoria Legal"
                  description="Represenación legal para cualquier problema laboral que tengas, no dejes que tus derechos sean pisados."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="flip_to_front"
                  title="Constante actualización"
                  description="Trabajamos todo el año para poder brindar cada vez mas beneficios a nuestros afiliados."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="price_change"
                  title="Beneficios exclusivos"
                  description="Contamos con un sistema de beneficios exclusivos para afiliados."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Sin moverte de tu casa"
                  description="Hacé todas tus gestiones con el sindicato desde tu hogar sin necesidad de visitarnos, aunque si gustas puedes hacerlo."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
